<!--
 * @Version      : V1.0
 * @Date         : 2025-06-05 16:29:37
 * @fileName     : 合同到期提醒
 * @Description  :
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="签约日期(年)" porp="signingDateYear">
            <el-date-picker clearable v-model="formInline.signingDateYear" format="yyyy 年" value-format="yyyy"
              type="year" placeholder="请选择签约日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收款合同" porp="id">
            <el-select clearable v-model="queryForm.id" filterable placeholder="请选择收款合同">
              <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" porp="customerId">
            <el-select clearable filterable v-model="queryForm.customerId" placeholder="请选择客户">
              <el-option v-for="item in customerOption" :key="item.id" :label="item.customerName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="我方负责人" porp="ownerChargePersonId">
            <el-select clearable filterable v-model="queryForm.ownerChargePersonId" placeholder="请选择我方负责人">
              <el-option v-for="item in ownerChargePersonOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="tab-switch py-10">
      <el-radio-group v-model="activeTab">
        <el-radio-button v-for="tab in tabs" :key="tab.key" :label="tab.key" :class="tab.cssClass">
          <span class="tab-btn-text">{{ tab.label }}</span>
          <span class="tab-btn-count">{{ (tabDataMap[tab.key] && tabDataMap[tab.key].count) || 0 }}</span>
        </el-radio-button>
      </el-radio-group>
    </div>

    <div class="operate py-20 border-box">
      <el-row :gutter="40">
        <el-col :span="12">
          <div class="box-card-sum" :class="{ 'box-card-sum-expired': currentTab.isExpired }">
            <div class="sum-title">
              <span class="font-small">{{ currentTab.isExpired ? '已到期合同数' : '即将到期合同数' }}</span>
            </div>
            <div class="sum-bg">
              <el-statistic group-separator="," :value="currentTabData.count"
                :value-style="{ fontSize: '35px', color: '#FFF' }"></el-statistic>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="box-card-sum" :class="{ 'box-card-sum-expired': currentTab.isExpired }">
            <div class="sum-title">
              <span class="font-small">{{ currentTab.isExpired ? '已到期合同总额' : '即将到期合同总额' }}</span>
            </div>
            <div class="sum-bg">
              <el-statistic group-separator="," :precision="2" :value-style="{ fontSize: '35px', color: '#FFF' }"
                :value="currentTabData.totalAmount"></el-statistic>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table-con">
      <div class="table-toolbar">
        <span class="table-title">{{ currentTab.label }}合同明细</span>
        <el-button type="primary" icon="el-icon-download" :loading="exportLoading" @click="exportExcel">导出</el-button>
      </div>
      <tableComponent :columns="columns" :tableData="currentTabData.list"
        @preSizeChange="handleSizeChange"
        @preCurrentChange="handleCurrentChange" :loading="currentTabData.loading" :pagination="currentTabData.pagination">
        <template #contractNameSlot="{ row }">
          <span class="link-text" @click="openContractDetail(row)">{{ row.contractName }}</span>
        </template>
        <template #ifStopServiceSlot="{ row }">
          <div>
            <el-tag :type="row.ifStopService == 1 ? 'danger' : 'success'" effect="dark">{{ row.ifStopService == 0 ? "否" : "是"
              }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="renewal(row)" v-if="row.ifStopService == 0 && !isGeneralManager">续签</el-button>
            <el-button type="text" @click="stopService(row)" v-if="row.ifStopService == 0">停止服务</el-button>
          </div>
        </template>
      </tableComponent>
    </div>

    <!-- 收款合同详情/续签抽屉（点击合同打开详情 / 点击续签直接打开续签） -->
    <contract-detail-drawer
      ref="contractDetailRefs"
      :title="contractDetailTitle"
      :status="contractDetailStatus"
    ></contract-detail-drawer>

  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import { auditProcessStatus, formatterState } from '@/utils/index'
import { downloadBlobFile } from '@/utils/common'
// 注意：receivableContract 目录名末尾含零宽非连接符 U+200C，此处用 \u200c 表示
import ContractDetailDrawer from '@/views/receivableContract\u200c/components/myContractDetails.vue'
import {
  queryPageForNearExpirationApi,
  setStopServiceApi,
  getNearExpirationDataApi,
  getExpiredContractsApi,
  pageForExpiredContractsApi
} from '@/api/contractExpirationReminder/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { querySupplierInfoListApi, queryChargeListtApi } from '@/api/basicInfo/index'

export default {
  components: {
    tableComponent,
    ContractDetailDrawer,
  },
  data() {
    return {
      activeTab: 'upcoming_30',
      detailsT: '收款合同台账详情',
      formInline: {
        signingDateYear: ""
      },
      queryForm: {
        id: "",
        customerId: "",
        ownerChargePersonId: ""
      },
      receivableContractOption: [],
      customerOption: [],
      ownerChargePersonOption: [],
      tabs: [
        // 还有30天及以内到期：end_date ∈ [今天, 今天+30]
        { key: 'upcoming_30', label: '30天内到期', minDays: 0, maxDays: 30, isExpired: false, cssClass: 'tab-btn-upcoming-30' },
        // 31~60天到期：end_date ∈ [今天+31, 今天+60]
        { key: 'upcoming_60', label: '31-60天到期', minDays: 31, maxDays: 60, isExpired: false, cssClass: 'tab-btn-upcoming-60' },
        // 已到期30天内：end_date ∈ [今天-30, 今天-1]
        { key: 'expired_30', label: '已到期30天内', minDays: -30, maxDays: -1, isExpired: true, cssClass: 'tab-btn-expired-30' },
        // 已到期超过30天：end_date ≤ 今天-31
        { key: 'expired_60', label: '已到期超过30天', minDays: -9999, maxDays: -31, isExpired: true, cssClass: 'tab-btn-expired-60' },
      ],
      tabDataMap: {
        upcoming_30: { count: 0, totalAmount: 0, list: [], loading: false, pagination: { pageCount: 7, total: 0, pageSize: 1, pageSizes: [10, 20, 100] } },
        upcoming_60: { count: 0, totalAmount: 0, list: [], loading: false, pagination: { pageCount: 7, total: 0, pageSize: 1, pageSizes: [10, 20, 100] } },
        expired_30: { count: 0, totalAmount: 0, list: [], loading: false, pagination: { pageCount: 7, total: 0, pageSize: 1, pageSizes: [10, 20, 100] } },
        expired_60: { count: 0, totalAmount: 0, list: [], loading: false, pagination: { pageCount: 7, total: 0, pageSize: 1, pageSizes: [10, 20, 100] } },
      },
      preStatus: '',
      contractDetailStatus: 'view',
      exportLoading: false,
      contractDetailTitle: '收款合同台账详情',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "contractNameSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "客户联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户联系电话", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "110px",
          keyName: "customerContactPhone", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "合同签约时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "signingDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "合同开始时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "startDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "合同结束时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "endDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "合同期限(天)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractDuration", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "到期时间(天)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "expirationTimeDays", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "是否停止服务", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "ifStopService", // 数据的属性值
          align: "center",
          slotName: "ifStopServiceSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "操作", // 标题名称
          fixed: "right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
    }
  },
  computed: {
    currentTab() {
      return this.tabs.find(t => t.key === this.activeTab) || this.tabs[0]
    },
    currentTabData() {
      return this.tabDataMap[this.activeTab] || this.tabDataMap['upcoming_30']
    },
    // 是否总经理（ifZjl == 1）：总经理不能续签，只能停止服务
    isGeneralManager() {
      return this.$store.state.user.ifZjl == 1
    }
  },
  mounted() {
    this.loadAllTabsData()
    this.getLedgerContractList()
    this.getCurtomer()
    this.getChargeList()
  },
  methods: {
    auditProcessStatus,
    formatterState,
    // 将天数偏移转换为实际日期字符串 { endDateStart, endDateEnd }
    getDateRange(tab) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)  // 当天零点
      const dateRange = {}

      // endDateStart：今天 + minDays（-9999 表示不设下限）
      if (tab.minDays > -9000) {
        const startDate = new Date(today.getTime())
        startDate.setDate(today.getDate() + tab.minDays)
        dateRange.endDateStart = this.fmtDate(startDate)
      }
      // endDateEnd：今天 + maxDays
      if (tab.maxDays != null) {
        const endDate = new Date(today.getTime())
        endDate.setDate(today.getDate() + tab.maxDays)
        dateRange.endDateEnd = this.fmtDate(endDate)
      }
      return dateRange
    },
    // 格式化日期为 yyyy-MM-dd
    fmtDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return y + '-' + m + '-' + d
    },
    // 加载所有tab的列表+统计数据
    loadAllTabsData() {
      this.tabs.forEach(tab => {
        this.loadTabStats(tab)
        this.loadTabList(tab)
      })
    },
    // 查询（筛选条件变化时重新加载全部tab）
    queryData() {
      this.loadAllTabsData()
    },
    // 加载当前tab列表数据
    loadTabList(tab, paginationItem = {}) {
      const tabData = this.tabDataMap[tab.key]
      tabData.loading = true
      const dateRange = this.getDateRange(tab)
      let params = {
        pageNum: paginationItem.pageNum || "1",
        pageSize: paginationItem.pageSize || "10",
        query: {
          params: {
            signingDateYear: "",
            ...this.formInline,
            ...dateRange     // endDateStart / endDateEnd
          },
          id: "",
          customerId: "",
          ownerChargePersonId: "",
          ...this.queryForm
        }
      }
      const api = tab.isExpired ? pageForExpiredContractsApi : queryPageForNearExpirationApi
      api(params).then(res => {
        tabData.loading = false
        if (res && res.code == 200 && res.data) {
          tabData.list = res.data.rows || []
          tabData.pagination.total = res.data.total || 0
        }
      }).catch(() => {
        tabData.loading = false
      })
    },
    // 加载当前tab统计数据（按钮上的数量）
    loadTabStats(tab) {
      const tabData = this.tabDataMap[tab.key]
      const dateRange = this.getDateRange(tab)
      const api = tab.isExpired ? getExpiredContractsApi : getNearExpirationDataApi
      api(dateRange).then(res => {
        if (res && res.code == 200 && res.data) {
          tabData.count = Number(res.data.contractCount) || 0
          tabData.totalAmount = Number(res.data.totalAmount) || 0
        }
      }).catch(() => {
        tabData.count = 0
        tabData.totalAmount = 0
      })
    },
    renewal(row) {
      if (!row || !row.id) {
        this.$message.warning('未获取到该合同信息')
        return
      }
      this.contractDetailStatus = 'renewal'
      this.contractDetailTitle = '收款合同续签'
      this.$nextTick(() => {
        this.$refs.contractDetailRefs.openDrawer(row)
      })
    },
    // 分页事件 — 使用当前tab
    handleSizeChange(page) {
      const tab = this.currentTab
      this.loadTabList(tab, { pageSize: page })
    },
    handleCurrentChange(value) {
      const tab = this.currentTab
      this.loadTabList(tab, { pageNum: value })
    },
    // 重置搜索form
    resetData(formName) {
      this.formInline.signingDateYear = ""
      this.queryForm.id = ""
      this.queryForm.customerId = ""
      this.queryForm.ownerChargePersonId = ""
      this.$nextTick(() => {
        this.loadAllTabsData()
      })
    },
    // 查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName: "",
        }
      }
      this.selectLoading = true
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false
        if (res.code == 200) {
          this.receivableContractOption = res.data
        }
      })
    },
    // 获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
          this.customerOption = res.data
        }
      })
    },
    // 我方负责人下拉
    getChargeList() {
      let params = {}
      queryChargeListtApi(params).then(res => {
        if (res.code == 200) {
          this.ownerChargePersonOption = res.data
        }
      })
    },
    stopService(row) {
      this.$confirm('确定停止服务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const tabData = this.currentTabData
        tabData.loading = true
        setStopServiceApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
          tabData.loading = false
          // 停止服务后重新加载当前tab
          this.loadTabList(this.currentTab)
          this.loadTabStats(this.currentTab)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出当前 tab 筛选条件下的全部数据
    exportExcel() {
      const tab = this.currentTab
      const dateRange = this.getDateRange(tab)
      this.exportLoading = true
      const params = {
        pageNum: '1',
        pageSize: '10000',
        query: {
          params: {
            signingDateYear: '',
            ...this.formInline,
            ...dateRange
          },
          id: '',
          customerId: '',
          ownerChargePersonId: '',
          ...this.queryForm
        }
      }
      const api = tab.isExpired ? pageForExpiredContractsApi : queryPageForNearExpirationApi
      api(params).then(res => {
        this.exportLoading = false
        if (res && res.code == 200 && res.data) {
          const list = res.data.rows || []
          if (!list.length) {
            this.$message.warning('当前筛选条件下没有可导出的数据')
            return
          }
          this.exportListToExcel(list, tab.label)
        }
      }).catch(() => {
        this.exportLoading = false
        this.$message.error('导出失败，请稍后重试')
      })
    },
    // 点击合同，打开收款合同台账详情抽屉
    openContractDetail(row) {
      if (!row || !row.id) {
        this.$message.warning('未获取到该合同信息')
        return
      }
      this.contractDetailStatus = 'view'
      this.contractDetailTitle = '收款合同台账详情'
      this.$nextTick(() => {
        this.$refs.contractDetailRefs.openDrawer(row)
      })
    },
    // 将列表数据导出为 .xls（HTML 表格，Excel 可直接打开）
    exportListToExcel(list, sheetName) {
      const exportCols = [
        { title: '合同名称', key: 'contractName' },
        { title: '项目类型', key: 'projectTypeName' },
        { title: '客户名称', key: 'customerName' },
        { title: '客户联系人', key: 'customerChargePerson' },
        { title: '客户联系电话', key: 'customerContactPhone', text: true },
        { title: '我方单位', key: 'ownerUnitName' },
        { title: '我方负责人', key: 'ownerChargePersonName' },
        { title: '合同金额(元)', key: 'contractAmount' },
        { title: '合同签约时间', key: 'signingDate' },
        { title: '合同开始时间', key: 'startDate' },
        { title: '合同结束时间', key: 'endDate' },
        { title: '合同期限(天)', key: 'contractDuration' },
        { title: '到期时间(天)', key: 'expirationTimeDays' },
        { title: '是否停止服务', key: 'ifStopService', fmt: v => (v == 1 ? '是' : '否') },
      ]
      const head = '<tr>' + exportCols.map(c => `<th>${c.title}</th>`).join('') + '</tr>'
      const body = list.map(row => {
        const tds = exportCols.map(c => {
          let val = row[c.key]
          if (val === undefined || val === null) val = ''
          if (c.fmt) val = c.fmt(val)
          val = String(val).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          const style = c.text ? ' style="mso-number-format:\'\\@\'"' : ''
          return `<td${style}>${val}</td>`
        }).join('')
        return `<tr>${tds}</tr>`
      }).join('')
      const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="UTF-8"></head><body><table border="1">${head}${body}</table></body></html>`
      downloadBlobFile('\ufeff' + html, `合同到期提醒-${sheetName}.xls`)
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    max-width: 1400px;
    margin: 0 auto;
  }

  .tab-switch {
    text-align: center;
    margin: 15px 0;

    ::v-deep .el-radio-button {
      margin: 0 5px;

      .el-radio-button__inner {
        padding: 14px 36px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 8px !important;
        border: 2px solid #dcdfe6;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transition: all 0.3s;
      }

      &:first-child .el-radio-button__inner {
        border-left: 2px solid #dcdfe6;
      }
    }

    ::v-deep .tab-btn-upcoming-30 .el-radio-button__inner {
      background: #f0f9eb;
      color: #67c23a;
      border-color: #c2e7b0 !important;

      .tab-btn-count {
        background: #67c23a;
      }
    }

    ::v-deep .tab-btn-upcoming-30.is-active .el-radio-button__inner {
      background: #67c23a;
      color: #fff;
      border-color: #67c23a !important;
      box-shadow: 0 4px 14px rgba(103, 194, 58, 0.4);

      .tab-btn-count {
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
      }
    }

    ::v-deep .tab-btn-upcoming-60 .el-radio-button__inner {
      background: #fdf6ec;
      color: #e6a23c;
      border-color: #f5dab1 !important;

      .tab-btn-count {
        background: #e6a23c;
      }
    }

    ::v-deep .tab-btn-upcoming-60.is-active .el-radio-button__inner {
      background: #e6a23c;
      color: #fff;
      border-color: #e6a23c !important;
      box-shadow: 0 4px 14px rgba(230, 162, 60, 0.4);

      .tab-btn-count {
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
      }
    }

    ::v-deep .tab-btn-expired-30 .el-radio-button__inner {
      background: #fef0f0;
      color: #f56c6c;
      border-color: #fbc4c4 !important;

      .tab-btn-count {
        background: #f56c6c;
      }
    }

    ::v-deep .tab-btn-expired-30.is-active .el-radio-button__inner {
      background: #f56c6c;
      color: #fff;
      border-color: #f56c6c !important;
      box-shadow: 0 4px 14px rgba(245, 108, 108, 0.4);

      .tab-btn-count {
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
      }
    }

    ::v-deep .tab-btn-expired-60 .el-radio-button__inner {
      background: #fdf3f3;
      color: #c45656;
      border-color: #e6b8b8 !important;

      .tab-btn-count {
        background: #c45656;
      }
    }

    ::v-deep .tab-btn-expired-60.is-active .el-radio-button__inner {
      background: #c45656;
      color: #fff;
      border-color: #c45656 !important;
      box-shadow: 0 4px 14px rgba(196, 86, 86, 0.4);

      .tab-btn-count {
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
      }
    }
  }

  .tab-btn-text {
    margin-right: 6px;
  }

  .tab-btn-count {
    display: inline-block;
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #fff;
  }

  .box-card-sum {
    background-color: rgb(84, 188, 189);
    height: 100px;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;

    .sum-title {
      color: #f7f4f4;
      font-size: 17px;
    }

    .sum-bg {}
  }

  .box-card-sum-expired {
    background-color: rgb(219, 89, 89);
  }

  .query-con {
    text-align: center;
  }

  .operate {
    max-width: 1400px;
    margin: 0 auto;
  }

  .table-con {
    max-width: 1400px;
    margin: 0 auto;

    .table-toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .table-title {
        font-size: 16px;
        font-weight: 700;
        color: #303133;
      }
    }

    .link-text {
      color: #409eff;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
